import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Companion_getInstance1toimxkidoujm as Companion_getInstance } from '../../models/data.mjs';
import {
  KProperty02ce7r476m8633 as KProperty0,
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  KProperty1ca4yb4wlo496 as KProperty1,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  FormattedTextInput$_get_content_$ref_pok0f82dt5dx9gm3qog as FormattedTextInput$_get_content_$ref_pok0f8,
  FormattedTextInput$_get_hint_$ref_iu6w222csieh0dinqk as FormattedTextInput$_get_hint_$ref_iu6w22,
  FormattedTextInput$_set_hint_$ref_61akla19heaeuxat3bz as FormattedTextInput$_set_hint_$ref_61akla,
  FormattedTextInput$_get_align_$ref_vo3rx42n1o02e9pl5u3 as FormattedTextInput$_get_align_$ref_vo3rx4,
  FormattedTextInput$_set_align_$ref_2d9bik2ytvu11xvgwtq as FormattedTextInput$_set_align_$ref_2d9bik,
  FormattedTextInput3hltc3nesrzjq as FormattedTextInput,
} from './FormattedTextInput.commonHtml.mjs';
import { ElementWithAction109xd6kw8dlp as ElementWithAction } from '../InteractiveElement.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { Regexxgw0gjiagf4z as Regex } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/regex.mjs';
import { isDigit3mimrri4wkzop as isDigit } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/charJs.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceSubSequence1iwpdba8s3jc7 as charSequenceSubSequence,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function PhoneNumberFormat$isRawData$ref(p0) {
  return constructCallableReference((p0_0) => p0.isRawData_ofdar9_k$(p0_0.value_1), 1, 0, 121, 'isRawData', [p0]);
}
function PhoneNumberFormat$format$ref(p0) {
  return constructCallableReference((p0_0) => p0.format_rd602l_k$(p0_0), 1, 0, 122, 'format', [p0]);
}
function PhoneNumberInput$_get_content_$ref_seupzq() {
  return constructCallableReference((p0) => p0.get_content_h02jrk_k$(), 1, 0, 123);
}
var PhoneNumberInputClass;
function PhoneNumberInput() {
  if (PhoneNumberInputClass === VOID) {
    class $ {
      constructor(input) {
        return new.target.new_com_lightningkite_kiteui_views_direct_PhoneNumberInput_jmfdmm_k$(input);
      }
      static new_com_lightningkite_kiteui_views_direct_PhoneNumberInput_jmfdmm_k$(input) {
        var $this = createThis(this);
        $this.input_1 = input;
        $this.input_1.set_keyboardHints_w6k1he_k$(Companion_getInstance().phone_1);
        var tmp = PhoneNumberFormat$isRawData$ref(PhoneNumberFormat_USA_getInstance());
        $this.input_1.format_eymgoy_k$(tmp, PhoneNumberFormat$format$ref(PhoneNumberFormat_USA_getInstance()));
        $this.format_1 = PhoneNumberFormat_USA_getInstance();
        var tmp_0 = $this;
        var tmp_1 = KProperty0();
        tmp_0.content$delegate_1 = getPropertyCallableRef('content', 0, tmp_1, FormattedTextInput$_get_content_$ref_pok0f8($this.input_1), null);
        var tmp_2 = $this;
        var tmp0 = $this.input_1;
        var tmp_3 = KMutableProperty0();
        var tmp_4 = FormattedTextInput$_get_hint_$ref_iu6w22(tmp0);
        tmp_2.hint$delegate_1 = getPropertyCallableRef('hint', 0, tmp_3, tmp_4, FormattedTextInput$_set_hint_$ref_61akla(tmp0));
        var tmp_5 = $this;
        var tmp0_0 = $this.input_1;
        var tmp_6 = KMutableProperty0();
        var tmp_7 = FormattedTextInput$_get_align_$ref_vo3rx4(tmp0_0);
        tmp_5.align$delegate_1 = getPropertyCallableRef('align', 0, tmp_6, tmp_7, FormattedTextInput$_set_align_$ref_2d9bik(tmp0_0));
        return $this;
      }
      static new_com_lightningkite_kiteui_views_direct_PhoneNumberInput_w1yrw4_k$(context) {
        return this.new_com_lightningkite_kiteui_views_direct_PhoneNumberInput_jmfdmm_k$(new (FormattedTextInput())(context));
      }
      get_content_h02jrk_k$() {
        var tmp0 = this.content$delegate_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('content', 1, tmp, PhoneNumberInput$_get_content_$ref_seupzq(), null);
        return tmp0.get();
      }
      get_action_avldmn_k$() {
        return this.input_1.action_1;
      }
      get_context_h02k06_k$() {
        return this.input_1.get_context_h02k06_k$();
      }
      get_underlyingNativeElement_vngz33_k$() {
        return this.input_1.get_underlyingNativeElement_vngz33_k$();
      }
      get_parent_hy4reb_k$() {
        return this.input_1.get_parent_hy4reb_k$();
      }
      onStartup_vrxh3i_k$() {
        this.input_1.onStartup_vrxh3i_k$();
      }
      onShutdown_5jzxq3_k$() {
        this.input_1.onShutdown_5jzxq3_k$();
      }
      set_opacity_ecw914_k$(_set____db54di) {
        this.input_1.set_opacity_ecw914_k$(_set____db54di);
      }
      set_shown_mavbz5_k$(_set____db54di) {
        this.input_1.set_shown_mavbz5_k$(_set____db54di);
      }
      get_shown_iyiju0_k$() {
        return this.input_1.get_shown_iyiju0_k$();
      }
      get_visible_8zfvk9_k$() {
        return this.input_1.get_visible_8zfvk9_k$();
      }
      set_paddingByEdge_53g79y_k$(_set____db54di) {
        this.input_1.set_paddingByEdge_53g79y_k$(_set____db54di);
      }
      get_paddingByEdge_29dw58_k$() {
        return this.input_1.paddingByEdge_1;
      }
      set_safeAreaPadding_bpzgd4_k$(_set____db54di) {
        this.input_1.set_safeAreaPadding_bpzgd4_k$(_set____db54di);
      }
      set_themeChoice_py59um_k$(_set____db54di) {
        this.input_1.set_themeChoice_py59um_k$(_set____db54di);
      }
      get_themeChoice_22tyn3_k$() {
        return this.input_1.get_themeChoice_22tyn3_k$();
      }
      get_themeAndBack_k3yag2_k$() {
        return this.input_1.themeAndBack_1;
      }
      get_dragData_pas5on_k$() {
        return this.input_1.get_dragData_pas5on_k$();
      }
      get_dropTargetDelegate_fbdv1u_k$() {
        return this.input_1.get_dropTargetDelegate_fbdv1u_k$();
      }
      scrollIntoView_zcj1gb_k$(horizontal, vertical, animate) {
        this.input_1.scrollIntoView_zcj1gb_k$(horizontal, vertical, animate);
      }
      set_debugName_wihv62_k$(_set____db54di) {
        this.input_1.set_debugName_wihv62_k$(_set____db54di);
      }
      get_debugName_58dolx_k$() {
        return this.input_1.get_debugName_58dolx_k$();
      }
      set_describedBy_4bf3cf_k$(_set____db54di) {
        this.input_1.set_describedBy_4bf3cf_k$(_set____db54di);
      }
      get_driverValue_yh5neo_k$() {
        return this.input_1.get_driverValue_yh5neo_k$();
      }
      get_driverActions_8jqr2k_k$() {
        return this.input_1.get_driverActions_8jqr2k_k$();
      }
      driverDisplay_abwxi1_k$(options) {
        return this.input_1.driverDisplay_abwxi1_k$(options);
      }
      toString() {
        return this.input_1.toString();
      }
      invoke_bnq13k_k$(_this__u8e3s4, actionToCalculate) {
        return this.input_1.invoke_bnq13k_k$(_this__u8e3s4, actionToCalculate);
      }
      bind_gesskf_k$(_this__u8e3s4, master) {
        this.input_1.bind_gesskf_k$(_this__u8e3s4, master);
      }
      get_coroutineContext_115oqo_k$() {
        return this.input_1.get_coroutineContext_115oqo_k$();
      }
    }
    initMetadataForClass($, 'PhoneNumberInput', VOID, VOID, [ElementWithAction()]);
    PhoneNumberInputClass = $;
  }
  return PhoneNumberInputClass;
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  PhoneNumberFormat_USA_instance = new (PhoneNumberFormat$USA())();
}
var PhoneNumberFormat$USAClass;
function PhoneNumberFormat$USA() {
  if (PhoneNumberFormat$USAClass === VOID) {
    class $ extends PhoneNumberFormat() {
      constructor() {
        super('USA', 0);
        PhoneNumberFormat_USA_instance = this;
      }
      format_rd602l_k$(clean) {
        var tmp0_safe_receiver = substringOrNull(clean, 0, 3);
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.takeUnless' call
          var tmp_0;
          if (!isBlank(tmp0_safe_receiver)) {
            tmp_0 = tmp0_safe_receiver;
          } else {
            tmp_0 = null;
          }
          tmp = tmp_0;
        }
        var tmp1_elvis_lhs = tmp;
        var tmp_1;
        if (tmp1_elvis_lhs == null) {
          return '';
        } else {
          tmp_1 = tmp1_elvis_lhs;
        }
        var area = tmp_1;
        var g1 = substringOrNull(clean, 3, 6);
        var g2 = substringOrNull(clean, 6, 10);
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
        $l$block_0: {
          this_0.append_58al37_k$(_Char___init__impl__6a9atx(40));
          this_0.append_22ad7x_k$(area);
          if (area.length === 3) {
            this_0.append_22ad7x_k$(') ');
          }
          if (g1 == null) {
            break $l$block_0;
          }
          this_0.append_22ad7x_k$(g1);
          if (g1.length === 3) {
            this_0.append_58al37_k$(_Char___init__impl__6a9atx(45));
          }
          if (g2 == null) {
            break $l$block_0;
          }
          this_0.append_22ad7x_k$(g2);
        }
        return this_0.toString();
      }
    }
    initMetadataForClass($, 'USA');
    PhoneNumberFormat$USAClass = $;
  }
  return PhoneNumberFormat$USAClass;
}
var PhoneNumberFormat_USA_instance;
var PhoneNumberFormatClass;
function PhoneNumberFormat() {
  if (PhoneNumberFormatClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal) {
        super(name, ordinal);
        this.regex_1 = Regex().new_kotlin_text_Regex_acuq4a_k$('(?:\\+\\d+ )?\\(\\d{3}\\) \\d{3}-\\d{4}|(?:\\+\\d+)?\\d{10}|(?:\\+\\d+-)?\\d{3}-\\d{3}-\\d{4}|(?:\\+\\d+ )?\\d{3} \\d{3} \\d{4}');
      }
      isRawData_ofdar9_k$(char) {
        return isDigit(char);
      }
    }
    initMetadataForClass($, 'PhoneNumberFormat');
    PhoneNumberFormatClass = $;
  }
  return PhoneNumberFormatClass;
}
function substringOrNull(_this__u8e3s4, startIndex, endIndex) {
  if (!(0 <= startIndex ? startIndex <= (charSequenceLength(_this__u8e3s4) - 1 | 0) : false))
    return null;
  if (endIndex > charSequenceLength(_this__u8e3s4)) {
    // Inline function 'kotlin.text.substring' call
    var endIndex_0 = charSequenceLength(_this__u8e3s4);
    return toString(charSequenceSubSequence(_this__u8e3s4, startIndex, endIndex_0));
  }
  // Inline function 'kotlin.text.substring' call
  return toString(charSequenceSubSequence(_this__u8e3s4, startIndex, endIndex));
}
function PhoneNumberFormat_USA_getInstance() {
  static_init();
  return PhoneNumberFormat_USA_instance;
}
//region block: exports
export {
  PhoneNumberInput as PhoneNumberInput1tdzv8kpf7vme,
};
//endregion

//# sourceMappingURL=PhoneNumberInput.mjs.map
